import React, { useContext, useEffect, useRef, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  AccumulationChartComponent,
  AccumulationDataLabel,
  AccumulationLegend,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  PieSeries,
  Inject,
} from "@syncfusion/ej2-react-charts";
import { formatDate } from "@telerik/kendo-intl";
import InactiveAlert from "./InactiveAlert";
import { confirmAlert } from "react-confirm-alert";
import AppContext from "../../AppContext";
import axios from "axios";
import { BASE_URL, mapConfig } from "../../constant";
import KendoLoadingPanel from "../KendoLoadingPanel";
import { GoogleMap, OverlayView } from "@react-google-maps/api";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { useTranslation } from "react-i18next";
import Scheduler from "../master/AssetScheduler/Scheduler";
import { useNavigate } from "react-router-dom";

const AnyReactComponent = ({ text, id, status, assetName }) => {
  return (
    <div className="relative -mt-6 -ml-5">
      <div
        className={`${
          status === "Bad" ? "bg-red-800" : "bg-green-700"
        } absolute top-1 left-1 w-7 h-7 rounded-full animate-spin-slow`}
      ></div>
      <TooltipComponent content={assetName}>
        <img
          className="absolute left-0 rounded-full top-0 h-9 w-9 cursor-pointer"
          alt="asset"
          id={id}
          src={`${text}`}
          // onClick={() => navigate(`details/${id}`)}
        />
      </TooltipComponent>
    </div>
  );
};

const ActiveCell = (props) => (
  <td>
    <div
      className={`
        ${
          props.dataItem[props.field]
            ? "border-green-500 text-green-500"
            : "border-red-500 text-red-500"
        } rounded-2xl flex justify-center text-xs items-center h-6 w-16 border`}
    >
      {props.dataItem[props.field]
        ? props.t("masters.labels.active")
        : props.t("masters.labels.inactive")}
    </div>
  </td>
);

const NameCell = (props) => (
  <td>
    <div
      className={`
       flex justify-between px-5 text-xs `}
    >
      {props.dataItem[props.field]}

      {props.dataItem.assetSchedule?.length > 0 ? (
        <button
          type="button"
          onClick={() =>
            props.onShedulerShow(
              props.dataItem.scheduleEvent,
              props.dataItem[props.field]
            )
          }
        >
          <img src="scheduleIcon.svg" alt="ScheduleIcon" className="h-5" />
        </button>
      ) : null}
    </div>
  </td>
);

const HealthCell = (props) => (
  <td>
    <div
      className={`
          ${
            props.dataItem[props.field] === "Good"
              ? " border-green-600 bg-green-600 text-white"
              : " border-red-700 text-white bg-red-700"
          } ${
        !props.dataItem.active ? "h-0 w-5" : "rounded-full h-5 w-5"
      } flex justify-center items-center border`}
    >
      {/* {props.dataItem[props.field]} */}
    </div>
  </td>
);

const DateCell = (props) => {
  return (
    <td>
      {props.dataItem[props.field] ? (
        formatDate(
          props.getTimeZoneDateTime(props.dataItem[props.field]),
          "dd MMM yyyy hh:mm a"
        )
      ) : (
        <div className="text-red-500">{props.t("masters.labels.n/a")}</div>
      )}
    </td>
  );
};

const HealthMonitoring = () => {
  const scheduleObj = useRef();
  const { t } = useTranslation();
  const { authCtx, isLoaded, getTimeZoneDateTime, darkMode } =
    useContext(AppContext);
  const [zoomMarker, setZoomMarker] = useState(mapConfig);

  const InactiveAlertBtn = (e) => {
    const assetItem = e.dataItem
      ? assets.find((x) => x.id === e.dataItem.id)?.inactiveAlert
      : null;
    return (
      <td className="">
        <div className="flex items-center gap-1">
          <div className="flex border border-slate-400 rounded-md px-2 py-1">
            <div className="w-7 text-end">
              {assetItem?.days ?? 1}&nbsp;D&nbsp;:
            </div>
            <div className="w-7 text-end">
              {assetItem?.hour ?? 0}&nbsp;H&nbsp;:
            </div>
            <div className="w-7 text-end">{assetItem?.minute ?? 0}&nbsp;M</div>
          </div>
          <div className="w-8 flex justify-center items-center">
            {assetItem?.active ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="rgb(22,163,74)"
                class="w-4 h-4"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="gray"
                class="w-4 h-4"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
                />
              </svg>
            )}
            &nbsp;
          </div>
          <button
            className="flex flex-col justify-center items-center gap-1"
            onClick={() => onInactiveAlertPopup(e, "row")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
              />
            </svg>
          </button>
        </div>
      </td>
    );
  };

  const InactiveAlertHeaderBtn = (e) => {
    return (
      <div className="">
        <button
          className="flex justify-between w-full items-center gap-2"
          onClick={() => onInactiveAlertPopup(e, "header")}
        >
          {t("masters.labels.alrt")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
            />
          </svg>
        </button>
      </div>
    );
  };

  const onShedulerShow = (scheduleData, assetName) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="w-[70vw] px-5 py-5 bg-black text-white rounded-md flex-col">
            <div className="flex justify-between items-start pb-5">
              <div>{assetName + " " + t("masters.headerTexts.schedule")}</div>
              <div>
                <button type="button" onClick={onClose}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <Scheduler
              eventData={scheduleData}
              scheduleObj={scheduleObj}
              assets={[]}
              renderType={"scheduleList"}
              scheduleId={"list-scheduler"}
            />
          </div>
        );
      },
    });
  };

  const columns = [
    {
      field: "name",
      title: t("masters.fields.name"),
      show: true,
      width: "auto",
      cell: (props) => NameCell({ ...props, t, onShedulerShow }),
      filterable: true,
    },

    {
      field: "active",
      title: t("masters.fields.status"),
      show: true,
      width: "80",
      cell: (props) => ActiveCell({ ...props, t }),
      filterable: true,
    },

    {
      field: "status",
      title: t("masters.fields.health"),
      show: true,
      cell: HealthCell,
      width: "70",
      filterable: true,
    },

    {
      field: "lastDataRecieved",
      title: t("masters.fields.lstDataRecieved"),
      show: true,
      width: "150",
      cell: (props) => DateCell({ ...props, t, getTimeZoneDateTime }),
      filterable: true,
    },
    {
      field: "",
      title: t("masters.labels.alrt"),
      show: true,
      width: "180",
      headerCell: InactiveAlertHeaderBtn,
      cell: InactiveAlertBtn,
      filterable: true,
    },
  ];

  const defaultAlertConfig = {
    assetId: "",
    interval: {
      days: 1,
      hours: 0,
      minutes: 0,
    },
    emails: [],
    active: true,
  };
  //   const [stateColumns, setStateColumns] = useState(columns);
  const [healthData, setHealthData] = useState([]);
  const [filteredHealthData, setFilteredHealthData] = useState([]);
  const [activePie, setActivePie] = useState([]);
  const [healthPie, setHealthPie] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assets, setAssets] = useState([]);
  // const [zoomMarker, setZoomMarker] = useState(mapConfig);
  const [map, setMap] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedHealth, setSelectedHealth] = useState(null);
  const [refreshLoading, setRefreshLoading] = useState(false);
  // const [assetSchedules,setAssetSchedules]=useState

  const onInactiveAlertPopup = (e, btnType) => {
    let dataItem = e.dataItem;
    let assetItem = e.dataItem
      ? assets.find((x) => x.id === e.dataItem.id)?.inactiveAlert
      : null;
    let emails = assetItem?.emails?.map((x) => ({ value: x, label: x }));
    let form = {
      assetIds: btnType === "row" ? [dataItem.id] : assets.map((x) => x.id),
      interval: {
        days: assetItem?.days ?? defaultAlertConfig.interval.days,
        hours: assetItem?.hour ?? defaultAlertConfig.interval.hours,
        minutes: assetItem?.minute ?? defaultAlertConfig.interval.minutes,
      },
      emails: emails ?? defaultAlertConfig.emails,
      active: assetItem?.active,
    };
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <InactiveAlert
            alertConfig={form}
            onClose={onClose}
            onInactiveAlertSave={onInactiveAlertSave}
          />
        );
      },
    });
  };

  const processData = async (resHealthData, m) => {
    const assetSchedules = await loadAssetSchedules(resHealthData);
    const assetColorCompination = resHealthData.map((x, index) => {
      let hue;
      if (index * (360 / resHealthData.length) < 200) {
        hue = index * (360 / resHealthData.length);
      } else {
        hue = (index * (360 / resHealthData.length) + 60) % 360;
      }

      // Convert HSL color to RGB
      const color = `hsl(${hue}, 100%, 50%)`;
      return {
        assetId: x.id,
        color,
      };
    });
    const data = resHealthData.map((x) => {
      const schedule = assetSchedules.filter((z) =>
        z.scheduleData.some((y) => y.assetId === x.id)
      );
      const assetSchedule = schedule.map((z) => ({
        ...z,
        scheduleData: z.scheduleData.filter((y) => y.assetId === x.id),
      }));
      const scheduleEvent = assetSchedule
        .map((x) =>
          x.scheduleData.map((y) => {
            return {
              ...y,
              scheduleStart: x.startDate,
              scheduleEnd: x.endDate,
              scheduleName: x.name,
              scheduleId: x.id,
              schedules: y.schedules.map((z, i) => ({
                Id: `${y.assetId}-${i}`,
                StartTime: new Date(z.startTime),
                EndTime: new Date(z.endTime),
                assetId: y.assetId,
                assetName: y.assetName,
                assetColor: assetColorCompination.find(
                  (s) => s.assetId === y.assetId
                )?.color,
                scheduleId: x.id,
                scheduleName: x.name,
              })),
            };
          })
        )
        .flat();
      return {
        ...x,
        assetSchedule: assetSchedule,
        scheduleEvent: scheduleEvent,
        lastDataRecieved: x.lastDataRecieved
          ? getTimeZoneDateTime(x.lastDataRecieved)
          : null,
      };
    });

    setHealthData(data);
    setFilteredHealthData(data);
    setActivePie([
      {
        status: t("masters.labels.active"),
        assetCount: data.filter((x) => x.active).length,
        color: "#16a34a",
      },
      {
        status: t("masters.labels.inactive"),
        assetCount: data.filter((x) => !x.active).length,
        color: "#b91c1c",
      },
    ]);
    setHealthPie([
      {
        status: t("masters.labels.good"),
        assetCount: data.filter((x) => x.status === "Good").length,
        color: "#16a34a",
      },
      {
        status: t("masters.labels.bad"),
        assetCount: data.filter((x) => x.status === "Bad").length,
        color: "#b91c1c",
      },
    ]);
    setLoading(false);
    const markers = resHealthData.map((x) => x.latestLocation).filter((x) => x);
    setMapBounds(markers, m);
  };

  const loadData = async (m) => {
    const companyId = authCtx.profile?.companyId;
    const resData = await axios.get(
      `${BASE_URL}/api/AssetHealth?companyId=${companyId}`
    );
    if (resData.status === 200) processData(resData.data, m);
  };

  const loadAssets = async () => {
    setLoading(true);
    const companyId = authCtx.profile?.companyId;
    const resData = await axios.get(
      `${BASE_URL}/api/Asset/GetAssetInactiveAlertByCompany?companyId=${companyId}`
    );
    setAssets(resData.data);
    return resData.data;
  };

  const onInactiveAlertSave = async (data) => {
    const updatedAsset = {
      assetIds: data.assetIds,
      inactiveAlert: {
        days: data.interval.days,
        hour: data.interval.hours,
        minute: data.interval.minutes,
        emails: data.emails.map((email) => email.value),
        active: data.active,
      },
    };
    const res = await axios.post(`${BASE_URL}/api/AssetHealth`, updatedAsset);
    if (res.status === 200) {
      setAssets(
        assets.map((asset) =>
          updatedAsset.assetIds.includes(asset.id)
            ? { ...asset, inactiveAlert: updatedAsset.inactiveAlert }
            : asset
        )
      );
    }
  };

  const setMapBounds = (markers, m) => {
    const bounds = new window.google.maps.LatLngBounds();
    markers.map((marker) => {
      bounds.extend({
        lat: parseFloat(marker.latitude),
        lng: parseFloat(marker.longitude),
      });
    });
    m?.fitBounds(bounds);
  };

  const onGraphSelectionChange = (filterType, statusType) => {
    if (statusType === "Active") {
      setSelectedStatus((pre) => {
        if (pre === null || pre === (filterType === "Active" ? 1 : 0)) {
          let filteredData =
            filterType === "Active"
              ? healthData.filter((x) => x.active)
              : healthData.filter((x) => !x.active);
          if (selectedHealth !== null) {
            if (selectedHealth === 0)
              filteredData = filteredData.filter((x) => x.status === "Bad");
            else if (selectedHealth === 1)
              filteredData = filteredData.filter((x) => x.status === "Good");
          }
          setFilteredHealthData(filteredData);
          return filterType === "Active" ? 0 : 1;
        } else {
          let filteredData = healthData;
          if (selectedHealth !== null) {
            if (selectedHealth === 0)
              filteredData = filteredData.filter((x) => x.status === "Bad");
            else if (selectedHealth === 1)
              filteredData = filteredData.filter((x) => x.status === "Good");
          }
          setFilteredHealthData(filteredData);
          return null;
        }
      });
    } else if (statusType === "Health") {
      setSelectedHealth((pre) => {
        if (pre === null || pre === (filterType === "Good" ? 1 : 0)) {
          let filteredData =
            filterType === "Good"
              ? healthData.filter((x) => x.status === "Good")
              : healthData.filter((x) => x.status === "Bad");
          if (selectedStatus !== null) {
            if (selectedStatus === 1)
              filteredData = filteredData.filter((x) => !x.active);
            else if (selectedStatus === 0)
              filteredData = filteredData.filter((x) => x.active);
          }
          setFilteredHealthData(filteredData);
          return filterType === "Good" ? 0 : 1;
        } else {
          let filteredData = healthData;
          if (selectedStatus !== null) {
            if (selectedStatus === 1)
              filteredData = filteredData.filter((x) => !x.active);
            else if (selectedStatus === 0)
              filteredData = filteredData.filter((x) => x.active);
          }
          setFilteredHealthData(filteredData);
          return null;
        }
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      // Your function here
      loadData(map);
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    return () => clearInterval(interval);
  }, []);

  function getCurrentFormattedDate() {
    const today = getTimeZoneDateTime(new Date());
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const loadAssetSchedules = async (assetData) => {
    const payload = {
      assetIds: assetData.map((x) => x.id),
      date: getCurrentFormattedDate(),
    };
    const resData = await axios.post(
      `${BASE_URL}/api/AssetScheduler/GetScheduledAssets`,
      payload
    );
    return resData.data;
  };

  const loadFns = async (m) => {
    setLoading(true);
    loadAssets();
    await loadData(m);
    setLoading(false);
  };

  const OnRefresh = async () => {
    setRefreshLoading(true);
    const res = await axios.get(
      `${BASE_URL}/api/AssetHealth/RefreshAssetHealth?companyId=${authCtx.profile.companyId}`
    );
    if (res.status === 200) {
      processData(res.data, map);
    }
    setRefreshLoading(false);
  };

  return (
    <div className="flex flex-col gap-5 text-white px-14 py-5 dark:bg-darkModeBg bg-lightModeBg h-full">
      <div className="flex text-xs lg:text-lg font-medium gap-3 justify-between items-center">
        <label className="dark:text-white text-labels">
          {t("masters.headerTexts.healthMonitoring")}
        </label>
        <button
          className="dark:bg-neutral-600 bg-HMTRefreshBtn px-3 py-1 items-center flex gap-2 text-xs rounded-md disabled:opacity-40 disabled:cursor-not-allowed"
          disabled={!map || loading}
          onClick={OnRefresh}
        >
          <img
            src="refreshIcon.svg"
            alt="RefreshIcon"
            className={`h-5 ${refreshLoading ? "animate-spin" : ""}`}
          />
          <label className="dark:text-white text-labels">Refresh</label>
        </button>
      </div>
      <div className="flex gap-5 h-60 w-full dark:text-white text-labels">
        <div className="flex flex-col items-center px-16 rounded-lg dark:bg-neutral-800 bg-HMTcards">
          <label className="text-lg pt-2">
            {t("masters.headerTexts.assets")}
          </label>
          <label className="text-6xl h-full flex items-center">
            {healthData.length}
          </label>
        </div>
        <div className="flex flex-col justify-center rounded-lg w-full dark:bg-neutral-800 bg-HMTcards">
          <label className="text-lg pt-5 px-5">
            {t("masters.headerTexts.assetStatus")}
          </label>

          <AccumulationChartComponent
            id="chartssss"
            legendSettings={{ visible: true }}
            enableSmartLabels
            height="200"
            width="100%"
            pointClick={(e) => onGraphSelectionChange(e.point.x, "Active")}
            selectionMode="Point"
          >
            <Inject
              services={[PieSeries, AccumulationLegend, AccumulationDataLabel]}
            />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={activePie}
                xName="status"
                pointColorMapping="color"
                yName="assetCount"
                type="Pie"
                radius="70"
                explode={true}
                explodeOffset="10%"
                explodeIndex={selectedStatus}
                dataLabel={{
                  visible: true,
                  name: "week",
                  position: "Outside",
                  font: { color: darkMode ? "white" : "black" },
                }}
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        </div>
        <div className="flex flex-col justify-center rounded-lg w-full dark:bg-neutral-800 bg-HMTcards">
          <label className="text-lg pt-5 px-5">
            {t("masters.headerTexts.assetHealth")}
          </label>
          <AccumulationChartComponent
            id="chart"
            legendSettings={{ visible: true }}
            height="200"
            width="100%"
            pointClick={(e) => onGraphSelectionChange(e.point.x, "Health")}
          >
            <Inject
              services={[PieSeries, AccumulationLegend, AccumulationDataLabel]}
            />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={healthPie}
                xName="status"
                yName="assetCount"
                pointColorMapping="color"
                type="Pie"
                radius="70"
                explode={true}
                explodeOffset="10%"
                explodeIndex={selectedHealth}
                dataLabel={{
                  visible: true,
                  name: "week",
                  position: "Outside",
                  font: { color: darkMode ? "white" : "black" },
                }}
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        </div>
      </div>
      <div className="h-1/2 flex  gap-2">
        <div
          className={`h-full w-1/2 border rounded-xl dark:border-neutral-800 ${
            darkMode ? "darkGrid" : "lightGrid"
          }`}
        >
          {loading && <KendoLoadingPanel />}
          <Grid
            style={{
              height: "100%",
              width: "100%",
              backgroundColor: "#181921",
              borderRadius: "15px",
              textAlign: "justify",
              overflowY: "auto",
              scrollbarGutter: "auto",
              scrollBehavior: "smooth",
              scrollbarWidth: "auto",
            }}
            data={filteredHealthData}
          >
            {columns.map(
              (column, idx) =>
                column.show && (
                  <GridColumn
                    key={idx}
                    field={column.field}
                    title={column.title}
                    filterable={column.filterable}
                    cell={column.cell}
                    width={column.width}
                    headerCell={column.headerCell}
                    className="product-name"
                  />
                )
            )}
          </Grid>
        </div>
        <div className="h-full w-1/2  border rounded-xl dark:border-neutral-800">
          {isLoaded ? (
            <GoogleMap
              center={mapConfig.center}
              zoom={mapConfig.zoom}
              mapContainerStyle={{
                height: "100%",
                width: "100%",
                borderRadius: "12px",
              }}
              options={{
                // styles: mapConfig.styles,
                styles: darkMode ? zoomMarker.styles : zoomMarker.styleLight,
                mapTypeControl: true,
                fullscreenControl: false,
                streetViewControl: false,
                // mapTypeControl: false,
              }}
              onLoad={(m) => {
                setMap(m);
                loadFns(m);
              }}
            >
              {healthData &&
                healthData.map((a) => {
                  return a.latestLocation &&
                    a.latestLocation.latitude !== "0.0" ? (
                    <OverlayView
                      position={{
                        lat: a.latestLocation && a.latestLocation.latitude,
                        lng: a.latestLocation && a.latestLocation.longitude,
                      }}
                      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                      key={a.id}
                    >
                      <AnyReactComponent
                        id={a.id}
                        key={a.id}
                        text={
                          a.status === "Bad" ? "truckred.svg" : "GreenTruck.svg"
                        }
                        status={a.status}
                        assetName={a.name}
                      />
                    </OverlayView>
                  ) : null;
                })}
            </GoogleMap>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HealthMonitoring;
